
{
  "fr": {
    "configuratorLayerEditorModalCropImage": {
      "input": {
        "zoom": {
          "label": "Zoom"
        },
        "rotation": {
          "label": "Rotation"
        }
      },
      "action": {
        "submit": {
          "label": "Valider",
          "title": "@:configuratorLayerEditorModalCropImage.action.submit.label"
        },
        "cancel": {
          "label": "Retour",
          "title": "@:configuratorLayerEditorModalCropImage.action.cancel.label"
        }
      }
    }
  }
}
